@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.drawer {
  position: fixed;
  inset: 0;
  z-index: var(--cxy-z-index-overlay);
  display: flex;
}

.drawerOverlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.8);
}

.drawerContent {
  position: fixed;
  inset-block: auto;
  inset-inline-end: 0;
  bottom: 0;
  height: 66vh;
  width: 100%;
  background-color: var(--cxy-color-surface-default);
  box-shadow: var(--cxy-box-shadow-a);
  color: var(--cxy-color-text-default-body);
  border-radius: var(--cxy-border-radius-l) var(--cxy-border-radius-l) 0 0;
}

.drawerHeader {
  display: grid;
  gap: var(--cxy-spacing-xxsm);
  padding: var(--cxy-spacing-xsm);
  text-align: center;

  @media (min-width: 640px) {
    text-align: left;
  }
}

.drawerFooter {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-xxsm);
  padding: var(--cxy-spacing-xxsm);
}

.drawerTitle {
  @include cxy.font-size('heading-m-mobile');
}

.drawerDescription {
  @include cxy.font-size('text-s');
}
